import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';

const MASCOT_URL = 'https://d2zdlj1ifv8u1d.cloudfront.net/images/mascot.png';

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: '20px',
    padding: '24px 20px 20px',
    maxWidth: '400px',
    width: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    color: '#666666',
    padding: '8px',
  },
  mascotWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
  },
  mascotCircle: {
    width: '96px',
    height: '96px',
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: '#6CC36F',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },
  headline: {
    fontWeight: 600,
    fontSize: '1.05rem',
    color: '#4A4A4A',
    marginBottom: '14px',
    lineHeight: 1.35,
  },
  bodyLine: {
    fontSize: '0.95rem',
    color: '#4A4A4A',
    lineHeight: 1.45,
    marginBottom: '22px',
    padding: '0 4px',
  },
  bodyHighlight: {
    fontWeight: 700,
    color: '#6CC36F',
    whiteSpace: 'nowrap',
  },
  primaryBtn: {
    width: '100%',
    backgroundColor: '#2D6E2F',
    color: '#FFFFFF',
    fontWeight: 700,
    textTransform: 'none',
    borderRadius: '10px',
    padding: '14px 16px',
    fontSize: '1rem',
    marginBottom: '10px',
    '&:hover': {
      backgroundColor: '#255C27',
    },
  },
  primaryBtnLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  checkIcon: {
    fontSize: '1.25rem',
    color: '#FFFFFF',
    fill: '#FFFFFF',
  },
  secondaryBtn: {
    width: '100%',
    backgroundColor: '#E8EAED',
    color: '#4A4A4A',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '10px',
    padding: '14px 16px',
    fontSize: '0.95rem',
    '&:hover': {
      backgroundColor: '#DDE0E5',
    },
  },
}));

/**
 * Modal de upsell: arredondar quantidade de títulos para o próximo múltiplo de 5.
 */
export default function RoundUpPurchaseModal({
  open,
  onClose,
  onAccept,
  onDecline,
  currentTickets,
  suggestedTickets,
  suggestedTotalFormatted,
}) {
  const classes = useStyles();

  // Fechar o diálogo (X, clique fora, Esc) é desistir: não compra nada. Só os
  // dois botões seguem para o pedido — com a sugestão ou com a quantidade atual.
  function handleDialogClose(_event, reason) {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      onClose();
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: classes.paper }}
      aria-labelledby="round-up-purchase-title"
    >
      <IconButton
        className={classes.closeButton}
        aria-label="Fechar"
        onClick={onClose}
        size="small"
      >
        <CloseIcon />
      </IconButton>
      <div className={classes.mascotWrap}>
        <div className={classes.mascotCircle}>
          <img src={MASCOT_URL} alt="" />
        </div>
      </div>
      <Typography id="round-up-purchase-title" component="h2" className={classes.headline}>
        Que tal aumentar suas chances?
      </Typography>
      <Typography component="p" className={classes.bodyLine}>
        Você deseja comprar{' '}
        <span className={classes.bodyHighlight}>
          {suggestedTickets} títulos por {suggestedTotalFormatted}?
        </span>
      </Typography>
      <Button
        type="button"
        variant="contained"
        className={classes.primaryBtn}
        disableElevation
        onClick={onAccept}
      >
        <span className={classes.primaryBtnLabel}>
          <CheckIcon className={classes.checkIcon} />
          Sim, comprar
        </span>
      </Button>
      <Button
        type="button"
        className={classes.secondaryBtn}
        onClick={onDecline}
      >
        Não, permanecer com {currentTickets} títulos
      </Button>
    </Dialog>
  );
}
